import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from '@wix/wix-i18n-config';
import { i18n } from './i18n/client-i18n';
import { App } from './App/App';
import * as BIManager from './utils/bi';
import { DEVICE } from './utils/helpers';
import { initFullstory } from './utils/fullstory';
import supportChatWidget from '@wix/support-chat-widget-wrapper';
import { initCookieAndTagManagers } from './utils/initCookieAndTagManagers';
import { ContextProvider } from './context/ContextProvider';

const initialI18n = window.__INITIAL_I18N__;
const baseURL = window.__BASEURL__;
const initialState = window.__INITIAL_STATE__;
const consentPolicy = window.__CONSENT_POLICY__;
const device = window.__DEVICE__;
const biOptions = window.__BI__;
const activeExperiments = window.__ACTIVE_EXPERIMENTS__;

(() => {
  initCookieAndTagManagers({
    baseUrl: baseURL,
    consentPolicy,
    language: initialI18n.locale,
  });

  initFullstory();
  window.addEventListener('load', () => {
    void supportChatWidget.init({ origin: 'TemplatesViewer' });
  });

  BIManager.setBIOptions(biOptions);

  const render = activeExperiments?.includes('TemplateViewerHydrationRender') ? ReactDOM.hydrate : ReactDOM.render;
  render(
    <ContextProvider initialState={initialState}>
      <I18nextProvider i18n={i18n(initialI18n)}>
        <App mobile={device !== DEVICE.DESKTOP} />
      </I18nextProvider>
    </ContextProvider>,
    document.getElementById('root'),
  );
})();
